import React, {memo} from 'react';
import b_ from 'b_';

import {Button, Icon} from 'client/common/components/lego';

import './banner.css';

const b = b_.with('banner');

export interface BannerProps {
    className?: string;
    title?: string;
    text?: string;
    buttons?: {
        label: string;
        onClick: ({queryParams}: {queryParams?: Record<string, string>}) => void;
    }[];
    buttonsLabel?: string;
    linksQueryParams: Record<string, string>;
    onClose?: () => void;
}

const Banner = memo(function Banner(props: BannerProps) {
    const {
        className = '',
        title,
        text,
        buttons = [],
        buttonsLabel,
        linksQueryParams,
        onClose
    } = props;

    return (
        <div className={`${b()} ${className}`}>
            {title && <h2 className={b('title')}>{title}</h2>}
            {text && <p className={b('text')}>{text}</p>}
            <div className={b('buttons-row')}>
                {buttons.length > 0 && (
                    <div className={b('buttons')}>
                        {buttons.map(({label, onClick}, index) => {
                            const onClickFn = () => {
                                onClick({queryParams: linksQueryParams});
                            };

                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <Button key={index} size='m' view='white' onClick={onClickFn}>
                                    {label}
                                </Button>
                            );
                        })}
                    </div>
                )}
                {buttonsLabel && <p className={b('after-buttons-text')}>{buttonsLabel}</p>}
            </div>
            {onClose && (
                <Button
                    size='icon'
                    view='clear'
                    icon={(iconClassName: string) => (
                        <Icon className={iconClassName} type='cross-light' />
                    )}
                    className={b('button', {type: 'close'})}
                    onClick={onClose}
                />
            )}
        </div>
    );
});

export default Banner;
